import { version } from 'repositories/version';

export class ReleaseVersionDomain {
  static currentVersion(): string {
    return (
      process.env.REACT_APP_BUILD_VERSION ||
      `${process.env.NODE_ENV}-build-version`
    );
  }

  static async hasNewVersion(): Promise<boolean> {
    if (process.env.NODE_ENV !== 'production') {
      return false;
    }

    try {
      const response = await version.check();
      return response.version !== this.currentVersion();
    } catch (e) {
      console.error(e);
      return false;
    }
  }
}
